export default function Footer() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-line text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">嫩草视频</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed mb-4">
              聚合香蕉视频、红桃视频、蜜桃视频、91视频等高清影视资源，免费在线观看电影、电视剧、综艺，不卡顿不缓冲，最新剧集完整版一站即达。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 text-background-50/60 hover:text-primary-400 hover:bg-foreground-700 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              {[
                { label: '精选推荐', href: '#cards' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新动态', href: '#updates' },
                { label: '热播榜单', href: '#ranking' },
                { label: '精彩推荐', href: '#media' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleScrollTo(e, link.href)}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <nav className="flex flex-col gap-2.5">
              {['热门电影', '最新剧集', '综艺精选', '动漫专区', '纪录片库'].map((item) => (
                <a
                  key={item}
                  href="#cards"
                  onClick={(e) => handleScrollTo(e, '#cards')}
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item}
                </a>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              嫩草视频感谢所有合作伙伴的支持与信任。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; 2026 嫩草视频 — 高清影视资源聚合平台。本站内容仅供学习交流使用。
            </p>
            <div className="flex items-center gap-4">
              <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">
                服务条款
              </a>
              <a href="#hero" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">
                隐私政策
              </a>
              <a href="#contact" onClick={(e) => handleScrollTo(e, '#contact')} className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer whitespace-nowrap">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}